import {Button, Popconfirm, Space, Table} from "antd";
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import './index.scss'
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

const OfficeTable = ({data, deleteHandle}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const ScreenMD = useBreakpoint().md;
    const {data: {user} = {}} = useSelector((state) => state.auth);
    const roleName = user?.role?.name;

    const Delete = async (id) => {
        deleteHandle('/office', id);
    };
    const Edit = (id) => {
        navigate(`/office/add?editId=${id}`)
    };


    const columns = [

        {
            title: 'Офис',
            dataIndex: 'name',
            render: (text) => <p>{text}</p>,
        },
        {
            title: 'Код',
            dataIndex: 'key',
            render: (text) => <p>{text}</p>

        },

        {
            title: 'Событие',

            render: (_, record) => (
                <Space direction={ScreenMD ? 'horizontal' : 'vertical'} size={[3, 10]}>

                    <>
                        <Button size={ScreenMD ? 'middle' : 'small'} onClick={() => Edit(record._id)} type='dashed'
                                icon={<EditOutlined/>}/>
                        <Popconfirm
                            title={'Вы уверены, что хотите удалить это?'}
                            onConfirm={() => Delete(record._id)}>
                            <Button type='primary' size={"small"} danger icon={<DeleteOutlined/>}/>
                        </Popconfirm>
                    </>


                </Space>
            ),
        },
    ];

    return (
        <Table
            className={'work-time'}
            size='small'
            columns={columns}
            dataSource={data}
            rowKey={(record) => record._id}
            pagination={{responsive: true}}
        />
    );
};

export default OfficeTable;
